import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";
import { observer } from "mobx-react";
import * as React from "react";
import { HXMenu, HXMenuController } from "./HXMenu";
import { HXMenuButtonEl, HXMobileMenuButtonEl } from "./HXMenuButton.styles";
import styled from "styled-components";
const HXCommonMenuButton = observer((props) => {
    var _a;
    const { children, onClick, ...buttonProps } = props;
    const controller = new HXMenuController(props.onOpen, props.onClose);
    const ButtonEl = props.mobile ? HXMobileMenuButtonEl : HXMenuButtonEl;
    return (_jsxs(_Fragment, { children: [_jsx(ButtonEl, { startIcon: props.icon ? React.createElement(props.icon) : _jsx(MenuIcon, {}), endIcon: _jsx(ExpandMoreIcon, {}), onClick: (e) => {
                    controller.openMenu(e.currentTarget);
                    onClick === null || onClick === void 0 ? void 0 : onClick(e);
                    e.stopPropagation();
                }, ...buttonProps, children: (_a = props.buttonText) !== null && _a !== void 0 ? _a : props.buttonText }), _jsx(HXMenu, { controller: controller, position: props.position, children: children })] }));
});
export const HXMenuButton = styled(HXCommonMenuButton).attrs({ mobile: false }) ``;
export const HXMobileMenuButton = styled(HXCommonMenuButton).attrs({ mobile: true }) ``;
